import { GameManager } from "./game/game-manager";

const gameManager = new GameManager();
gameManager.start();
